import React, { Fragment } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import Api from '../../api/api';
import DinamicTable from '../common/dinamic-table';
import OverlayLoading from '../common/overlay-loading';

export default class AddressesAdmin extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            modal: false,
            id: null,
            form: {
                name: '',
                downPercent: 85,
                address: '',
            }
        }
    }

    componentDidMount = () => {
        this.updateTable();
    }

    updateTable = async () => {
        await this.setState({ loading: true });
        let req = await Api.get('addresses');
        if (!req.error) {
            let rows = req.data;
            console.log(rows)
            let cols = [
                'Name',
                'Real Value Percent',
                'Address',
                '<button>Edit',
            ]
            rows = rows.map(row => {
                return [
                    row.name,
                    row.downPercent,
                    row.address,
                    row,
                ]
            })
            this.table.updateTable(cols, rows);
        }
        await this.setState({ loading: false });
    }

    deleteRow = async (id) => {
        let response = window.confirm("ATTENTION!!! This action cannot be undone.");
        if (response) {
            let req = await Api.del(`addresses/${id}`);
            if (!req.error) {
                this.updateTable();
                this.setState({ modal: false })
            }
        }
    }

    openRow = (row) => {
        this.setState({
            modal: true,
            id: row.id,
            form: {
                name: row.name,
                downPercent: row.downPercent,
                address: row.address,
            }
        })
    }

    newRow = () => {
        this.setState({
            modal: true,
            id: null,
            form: {
                name: '',
                downPercent: 85,
                address: '',
            }
        })
    }

    saveRow = async () => {
        await this.setState({ loading: true });
        let form = this.state.form;
        if (this.state.id) {
            await Api.patch(`addresses/${this.state.id}`, {
                name: form.name,
                downPercent: parseInt(form.downPercent),
                address: form.address,
            })
        } else {
            await Api.post(`addresses`, {
                name: form.name,
                downPercent: parseInt(form.downPercent),
                address: form.address,
            })
        }
        this.updateTable();
        this.setState({ modal: false, loading: false })
    }

    handleChange = (event) => {
        let form = this.state.form
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
        form[event.target.name] = value
        this.setState({ form })
    }

    toggleModal = () => {
        this.setState({ modal: !this.state.modal })
    }

    render() {
        return (
            <Fragment>
                <OverlayLoading show={this.state.loading} />
                <div className="container-fluid pt-5">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col">
                                            <h5>Addresses</h5>
                                        </div>
                                        <div className="col">
                                            <div className="pull-right right-header">
                                                <button className="btn btn-primary" onClick={() => this.newRow()}>Create New Address</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <DinamicTable
                                    size="5"
                                    ref={ref => this.table = ref}
                                    openRow={this.openRow}
                                    deleteRow={this.deleteRow}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} size="lg" centered>
                    <ModalHeader toggle={this.toggleModal}>{this.state.id ? 'Edit' : 'New'} Address</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-md">
                                <div className="form-group">
                                    <label>Name</label>
                                    <input className="form-control"
                                        type="text"
                                        name="name"
                                        value={this.state.form.name}
                                        onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="col-md">
                                <div className="form-group">
                                    <label className='mt-2'>
                                        <span>Real Value Percent</span>
                                        {" "}
                                        <Badge>{this.state.form.downPercent} %</Badge>
                                    </label>
                                    <input className="w-100"
                                        type="range"
                                        min="0"
                                        max="100"
                                        name="downPercent"
                                        value={this.state.form.downPercent}
                                        onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label>Address</label>
                                    <input className="form-control"
                                        type="text"
                                        name="address"
                                        value={this.state.form.address}
                                        onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.id && <button className="btn btn-danger" style={{ marginRight: 'auto' }} onClick={() => this.deleteRow(this.state.id)}>Delete</button>}
                        <button className="btn btn-primary" onClick={this.saveRow}>Save</button>
                        <button className="btn btn-secondary" onClick={this.toggleModal}>Cancel</button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}